import { render, staticRenderFns } from "./UmsApplicationEditor.vue?vue&type=template&id=270610f5&"
import script from "./UmsApplicationEditor.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports